module.exports = __webpack_public_path__ + "img/memcached.dffc89b1.png";